import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { useEffect, useState } from "react";

const FeatureFormDialog = ({ open, onClose, onSubmit, initialData }) => {
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [error, setError] = useState("");

    const isEditMode = !!initialData;

    useEffect(() => {
        if (open && isEditMode) {
            setName(initialData.name || "");
            setDescription(initialData.description || "");
        }
    }, [open, initialData, isEditMode]);

    const handleSubmit = () => {
        if (!name.trim()) {
            setError({ name: "Name ist ein Pflichtfeld." });
            return;
        }
        if (!description.trim()) {
            setError({ description: "Beschreibung ist ein Pflichtfeld." });
            return;
        }
        onSubmit({ name, description });
        handleClose();
    };

    const handleClose = () => {
        setName("");
        setDescription("");
        setError("");
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>{isEditMode ? "Feature bearbeiten" : "Neues Feature erstellen"}</DialogTitle>
            <DialogContent>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}>
                    <TextField
                        autoFocus
                        label="Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        error={!!error?.name}
                        helperText={error?.name}
                        fullWidth
                        required
                    />
                    <TextField
                        label="Beschreibung"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        fullWidth
                        multiline
                        rows={3}
                        required
                        error={!!error?.description}
                        helperText={error?.description}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Abbrechen</Button>
                <Button onClick={handleSubmit} variant="contained">
                    {isEditMode ? "Speichern" : "Erstellen"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default FeatureFormDialog;
